import React, { useEffect, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  DialogTitle,
  Drawer,
  Grid,
  IconButton,
  Stack,
  Toolbar
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CmpTypographyField } from '../../component/ToolBox/ToolBox';
import { distributionPostApi, distributionVANApi } from '../Purchase/actions';

import { ItemDistributionModal } from './ProcessComponents/ItemDistributionModal';

import { VanItemCard } from './ProcessComponents/VanItemCard';
import { ItemvarianceModal } from './ProcessComponents/ItemvarianceModal';
import { fAlertToast } from '../../Utility/Utilitys';
import { confirmAlert } from 'react-confirm-alert';

const toolbar = {
  backgroundColor: '#0d73bb',
  color: 'white',
  display: 'flex',
  justifyContent: 'space-between',
  minHeight: '40px !important'
};

export default function DistributionItemListDrawer({
  open,
  onClose,
  data,
  setSelectedRow,
  fOnPageLoad
}) {
  const [sCardDetail, setCardDetail] = useState([]);
  const [sModalOpen, setModalOpen] = useState(false);
  const [Modalvariance, SetModalvariance] = useState(false);

  const [selectedItem, setSelectedItem] = useState(null);

  const fDetail = async () => {
    const obj = {
      VocTyp: data?.A_VocTyp,
      VocNo: data?.A_VocNo,
      Truck: data?.TruckID
    };
    const result = await distributionVANApi(obj);
    console.log('result,', result);

    if (result?.ResultSet?.DistriRows.length > 0) {
      setCardDetail(result?.ResultSet?.DistriRows);
    } else {
      setCardDetail([]);
    }
  };

  const fPost = async () => {
    const obj = {
      VN_VocTyp: data?.A_VocTyp,
      VN_VocNo: data?.A_VocNo,
      VN_Truck: data?.TruckID
    };
    const result = await distributionPostApi(obj);
    console.log('result,', result);
    if (result.Type === 'Success') {
      fAlertToast('SUCCESS', 'Post Successfully');
      await fOnPageLoad();
      setSelectedRow((prev) => ({
        ...prev,
        TruckStatus: true
      }));
    }
  };

  const fNew = () => {
    setModalOpen(true);
    setSelectedItem({
      A_TrnsId: 0,
      A_Loc: '',
      locName: '',
      A_Date: new Date(),
      A_Ref_VocTyp: '',
      A_Ref_VocNo: '',
      A_Ref_Truck: '',
      A_Status: 'ENTER',
      ApBy: '',
      ApDt: ''
    });
  };
  const fvariance = () => {
    SetModalvariance(true);
    setSelectedItem({
      A_TrnsId: 0,
      A_Loc: '',
      locName: '',
      A_Date: new Date(),
      A_Ref_VocTyp: '',
      A_Ref_VocNo: '',
      A_Ref_Truck: '',
      A_Status: 'ENTER',
      ApBy: '',
      ApDt: ''
    });
  };
  const fPostalert = () => {
    confirmAlert({
      title: 'Post',
      message: 'Are you sure to Post?',
      buttons: [
        {
          className: 'alertBtn',
          label: 'Yes',
          onClick: async () => {
            await fPost();
          }
        },
        {
          className: 'alertBtn',
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  };

  const fOnpressVanItem = (itm) => {
    setSelectedItem(itm);
    setModalOpen(true);
    //SetModalvariance(true);
  };

  const fClose = () => {
    setCardDetail([]);
    onClose();
  };

  useEffect(() => {
    if (open) {
      fDetail();
    }
  }, [open]);

  return (
    <Drawer anchor="right" open={open} onClose={fClose}>
      <Box role="presentation" sx={{ width: { xs: 330, sm: 510, md: 550 } }}>
        <Toolbar sx={toolbar}>
          <DialogTitle
            sx={{ backgroundColor: '#0d73bb', color: 'white', padding: '0 4px !important' }}>
            Van Item List
          </DialogTitle>
          <IconButton edge="end" color="inherit" onClick={fClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Toolbar>

        <Box sx={{ p: 2 }}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Grid
                container
                spacing={1}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                sx={{ alignItems: 'center' }}>
                <Grid item xs={3} sm={2.5} md={2.5}>
                  <CmpTypographyField xcomponent={'span'} xText={'Voucher Type'} />
                </Grid>
                <Grid item xs={0.5} sm={0.5} md={0.5}>
                  <CmpTypographyField xcomponent={'span'} xText={':'} />
                </Grid>
                <Grid item xs={8.5} sm={9} md={9}>
                  <CmpTypographyField
                    xcomponent={'span'}
                    xText={`${data?.A_VocTyp} - ${data?.VocName}`}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Grid
                container
                spacing={1}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                sx={{ alignItems: 'center' }}>
                <Grid item xs={3} sm={2.5} md={2.5}>
                  <CmpTypographyField xcomponent={'span'} xText={'Voucher'} />
                </Grid>
                <Grid item xs={0.5} sm={0.5} md={0.5}>
                  <CmpTypographyField xcomponent={'span'} xText={':'} />
                </Grid>
                <Grid item xs={8.5} sm={9} md={9}>
                  <CmpTypographyField xcomponent={'span'} xText={`${data?.A_VocNo}`} />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Grid
                container
                spacing={1}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                sx={{ alignItems: 'center' }}>
                <Grid item xs={3} sm={2.5} md={2.5}>
                  <CmpTypographyField xcomponent={'span'} xText={'Location'} />
                </Grid>
                <Grid item xs={0.5} sm={0.5} md={0.5}>
                  <CmpTypographyField xcomponent={'span'} xText={':'} />
                </Grid>
                <Grid item xs={8.5} sm={9} md={9}>
                  <CmpTypographyField xcomponent={'span'} xText={data?.LocName} />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Grid
                container
                spacing={1}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                sx={{ alignItems: 'center' }}>
                <Grid item xs={3} sm={2.5} md={2.5}>
                  <CmpTypographyField xcomponent={'span'} xText={'Truck'} />
                </Grid>
                <Grid item xs={0.5} sm={0.5} md={0.5}>
                  <CmpTypographyField xcomponent={'span'} xText={':'} />
                </Grid>
                <Grid item xs={8.5} sm={9} md={9}>
                  <CmpTypographyField xcomponent={'span'} xText={data?.TruckName} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Box
            sx={{
              height: sCardDetail.length >= 5 ? '70vh' : 'auto',
              overflowY: sCardDetail.length >= 5 ? 'auto' : 'visible',
              marginTop: { xs: 0.6, sm: 1.5, md: 1.5 }
            }}>
            {sCardDetail.length === 0 ? (
              <Box
                sx={{
                  minHeight: 200,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                <p style={{ fontSize: '2rem' }}>List is Empty</p>
              </Box>
            ) : (
              <Grid container spacing={1} paddingY={0.5}>
                {sCardDetail?.map((itm) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={6}
                    key={itm.VAN_SRNO}
                    onClick={() => fOnpressVanItem(itm)}>
                    <VanItemCard
                      xTransId={itm.A_TrnsId}
                      xLoc={itm.locName}
                      xDate={itm.A_Date}
                      xRefVocType={itm.A_Ref_VocTyp}
                      xRefVocNo={itm.A_Ref_VocNo}
                      xRefTruck={itm.A_Ref_Truck}
                      xApBy={itm.ApBy}
                      xApDt={itm.ApDt}
                      xStatus={itm.A_Status === 'POST'}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
          </Box>
          <Stack
            direction="row"
            spacing={2}
            textAlign={'center'}
            justifyContent={'center'}
            marginTop={'20px'}>
            <Button
              size="small"
              variant="contained"
              sx={{ textTransform: 'capitalize' }}
              onClick={fNew}
              disabled={data?.TruckStatus === true}>
              Add New
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={{ textTransform: 'capitalize' }}
              // onClick={fNew}
              onClick={fvariance}>
              Variance
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={{ textTransform: 'capitalize' }}
              onClick={fPostalert}
              disabled={data?.TruckStatus === true}>
              Post
            </Button>
          </Stack>
        </Box>
      </Box>

      <ItemDistributionModal
        open={sModalOpen}
        onClose={() => setModalOpen(false)}
        data={data}
        cardData={selectedItem}
        fVanDetail={fDetail}
        setSelectedItem={setSelectedItem}
      />
      <ItemvarianceModal
        open={Modalvariance}
        onClose={() => SetModalvariance(false)}
        data={data}
        cardData={selectedItem}
        fVanDetail={fDetail}
        setSelectedItem={setSelectedItem}
      />
    </Drawer>
  );
}
